module.exports = __webpack_public_path__ + "static/media/notification.ef39725f.mp3";